<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xyma7S/tc-custom/9781937829469.jpg?1714818041492" alt="This image is the cover for the book Listen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Listen
      </h1>
      <p class="bookDescription body article font2">
        <p>“From ethics to eros, Shirley Hall's poetry has an edge that sharply dissects the dilemmas of contemporary life. Hers is the voice of the prophet crying out for social justice; the voice of a compassionate human being seeking basic decency and dignity. More than mere entertainment and aesthetic experience, Hall's compositions provide insight and instruction, and are guaranteed to make your spirit sing.” Lance Strate Prof. of Communication and Media Studies Fordham University, New York ------ “...a spokesperson for others - brave at voicing wrongs - her poems have a courage behind them, a tongue free to unleash a fury…words that dig deep into ones soul. Marvelous!” Aine MacAodha Author: Where the Three Rivers Meet Omagh Ireland ------ “...a book for everyone who cares for the human condition and treasures the beauty of the word. A must read. ~ LISTEN… and learn” Constance Stadler, Ph.D Author: Tinted Steam, Sublunary Curse Washington DC / Virginia ------ “...poems that are moving, intelligent and thought provoking… she defines the essence of my group. A book you’ll read again and again” Joe Sting Cup of Coffee Networkers.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Shirley Howard Hall
      </h2>
      
      <p class="authorDescription body article">Shirley Howard Hall is the author of ONE DAY; Life, Love and Controversy in Middle America, LISTEN and EMBRACE as well as a contributor to Candy and Stars in Our Hearts: Moments. She is the recipient of various awards and her work has appeared in newspapers, magazines and blogs nation wide. An advocate for peace, freedom, and equality she challenges social, economical, religious, and political agendas through controversial, provocative, insightful, and inspirational poetry and essays. As a voice for the people behind the story her poems minister to current affairs and emotions; befitting life’s challenges - and our times. As a speaker she has presented her poems in colleges and universities, in social and professional venues, and in 1980 by special invitation to Ambassador Terrance Todman at the American Embassy in Madrid Spain. As owner of More Than Words her vitae ranges from specialized consignment pieces to corporate, group, and individual announcements, pamphlets, and personalized greetings. A diversified writer, widely read poet, and noted public speaker, her controversial bodies of work have 72 been used in university classes and is read and appreciated worldwide. For more informastion feel free to visit www.shirleyhallpoet.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Total Publishing and Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c21640d8